// web-v2/src/lib/v3-flag-probe.js
//
// WHAT THE /api/v3/status PROBE MEANS, as a pure function (no imports, so the
// gate runs it in node; lib/v3-flag.js is its one caller). Three answers:
// true (200, on), false (404 v3_api_disabled, off), null (anything else: not
// known). A failure that is not the flag's own refusal is never read as off.
export function v3FlagFromProbe(outcome) {
  if (outcome && outcome.ok === true) return true;
  const e = outcome && outcome.error;
  if (e && e.status === 404 && e.code === 'v3_api_disabled') return false;
  return null;
}

// THE ONCE-PER-LOAD READER over a probe (lane C review C-R7), here so the gate
// runs it in node with a stand-in probe instead of reading its source: a
// definite answer (true, false) is kept for the load; not known (null) is
// never kept, so the next caller asks again. lib/v3-flag.js builds the one
// reader the shell uses from getV3Status.
export function makeFlagReader(probe) {
  let answered = null;
  let inFlight = null;
  function readFlag() {
    if (answered !== null) return Promise.resolve(answered);
    if (!inFlight) {
      inFlight = Promise.resolve()
        .then(probe)
        .then(() => v3FlagFromProbe({ ok: true }), (error) => v3FlagFromProbe({ ok: false, error }))
        .then((v) => { inFlight = null; if (v !== null) answered = v; return v; });
    }
    return inFlight;
  }
  readFlag.peek = () => answered;
  return readFlag;
}
